/* eslint no-console: ["error", { allow: ["warn", "error"] }] */
import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { useField } from 'formik';
import apiService from '@services/apiService';

const FormikSelect = ({
  disabled,
  name,
  value,
  onBlur,
  onChange,
  multiselect,
  comboBoxLookupName,
}) => {
  const [field, , helpers] = useField(name);
  const [isLoading, setIsLoading] = useState(true);
  const [options, setOptions] = useState([]);

  const comboVal = useMemo(() => options.find(item => item.Code === value), [value, options]);

  useEffect(() => {
    if (comboBoxLookupName) {
      const getOptions = async () => {
        try {
          const [definitions] = await apiService.Definitions.PostToLookupTable({ lookupNames: [comboBoxLookupName] });
          setOptions(definitions.data);
          setIsLoading(false);
        } catch (er) {
          console.error('Error: FormikSelect comboBoxLookup', er);
        }
      };

      getOptions();
    }
  }, [comboBoxLookupName]);

  const handleChange = val => {
    const selectVal = multiselect && val?.length
      ? val.map(({ Code }) => Code)
      : val?.Code;
    if (field?.value === selectVal) return;
    if (onChange) {
      onChange(selectVal);
    } else {
      helpers.setValue(selectVal);
    }
  };

  return (
    <Select
      name={name}
      className="react-select-container"
      classNamePrefix="react-select"
      closeMenuOnSelect={!multiselect}
      isDisabled={disabled || isLoading}
      isMulti={multiselect}
      isClearable
      isLoading={isLoading}
      onBlur={onBlur}
      onChange={handleChange}
      options={options}
      menuPortalTarget={document.querySelector('body')}
      placeholder={`Choose one ${multiselect ? 'or more' : ''}`}
      getOptionLabel={({ Description }) => Description}
      getOptionValue={({ Code }) => Code}
      value={comboVal}
    />
  );
};

FormikSelect.propTypes = {
  disabled: PropTypes.bool,
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  multiselect: PropTypes.bool,
  comboBoxLookupName: PropTypes.string,
};

export default FormikSelect;
